import _ from "underscore";
import React from "react";
import {Layout, Screen, SideBar} from "../../components/layout";
import M from "../../../strings";
import {deleteEntities, freeEntities, loadEntities, updateQuery} from "../../../actions/entities";
import {ActionsMatcher, HeaderBlock} from "../../components/common";
import {Grid, resultToGridData} from "../../components/grids";
import * as query from "../../../framework/query";
import {format, optional, parseBoolean} from "../../../utils/lang";
import * as ui from "../../utils/ui";
import {Permission} from "../../../api/session";
import {discriminated} from "../../../utils/ajex";
import {connectDiscriminated} from "../../../utils/aj-react";
import {EntitiesStore, SearchStore} from "../../../stores/entities";
import { getEntityData } from "../../entities/entities";
import { confirm } from "../../../plugins";

class AbstractEntitiesGrid extends Screen {
    constructor(props) {
        super(props)

        if (_.isEmpty(this.getEntity())) {
            throw new Error("Please specify entity for form")
        }
        this.discriminator = "entity_grid_" + this.getEntity()
        let _query = this.getInitialQuery();
        this.state = {grid: null, result: null, query: _query}
        this.state.query.on("change", () => {
            updateQuery({discriminator: this.discriminator, query: this.state.query});
            this.onQueryChanged()
        })

        connectDiscriminated(this.discriminator, this, [EntitiesStore])
    }

    generateTableHeaderExtra() {
        let grid = this.getEntityGrid();
        if (_.isFunction(grid.generateTableExtraHeader))
            return <div className="grid-header-extra">{grid.generateTableExtraHeader(this.getEntity(), this.state.query)}</div>
        return null
    }


    getInitialQuery() {

        //TODO: non bellisimo: ricorrere alla action getQuery
        let state = optional(discriminated(optional(SearchStore.state, {}), this.discriminator), {});
        let _query;
        if (state ) {
            _query = state.query;
        }

        if (!_query)
            _query = this.getEntityGrid().initialQuery


        if (_.isFunction(this.getEntityGrid().initialQuery)) {
            _query = this.getEntityGrid().initialQuery()
        }
        if (!_query) {
            _query = query.create()
            _query.page = 1
            _query.rowsPerPage = 50
        }

        return _query;
    }


    getEntity() {
        return this.props.entity
    }

    getEntityGrid() {
        const entity = this.getEntity(),
            descriptorData = getEntityData(entity),
            entityGrid = descriptorData.grid;
        return entityGrid
    }

    componentDidMount() {
        loadEntities({discriminator: this.discriminator, entity: this.getEntity(), query: this.state.query})
    }

    componentWillUnmount() {
        freeEntities({discriminator: this.discriminator})
    }

    onQueryChanged() {
        loadEntities({discriminator: this.discriminator, entity: this.getEntity(), query: this.state.query})
    }

    editEntity(data) {
        if (!this.canEdit()) {
            return
        }

        ui.navigate(this.getEditUrl(data))
    }

    createEntity() {
        if (!this.canCreate()) {
            return
        }

        ui.navigate(this.getCreateUrl())
    }

    getCreateUrl() {
        let grid = this.getEntityGrid()
        let createUrl = grid.createUrl
        if (_.isFunction(createUrl)) {
            createUrl = createUrl()
        }
        return optional(createUrl, `/entities/${this.getEntity()}/new`)
    }

    getEditUrl(data) {
        let grid = this.getEntityGrid()
        if (_.isFunction(grid.editUrl)) {
            return format(grid.editUrl(data))
        } else if (!_.isEmpty(grid.editUrl)) {
            return format(grid.editUrl, data.id)
        } else {
            return `/entities/${this.getEntity()}/${data.id}`
        }
    }
    
    getDeleteMessage() {
        let message = format(M("entityDeleteConfirm"), this.refs.grid.getSelection().length)
        let entityMessage = this.getGrid().deleteMessage
        if (entityMessage)
            message = format("{0}\n{1}", message, entityMessage)
        return message;
    }

    getSelection() {
        return this.refs.grid.getSelection();
    }

    deleteEntities() {
        if (!this.canDelete()) {
            return
        }

        let selection = this.getSelection()
        if (_.isEmpty(selection)) {
            return
        }

        confirm(M("confirm"), this.getDeleteMessage())
            .then(() => {
                deleteEntities({discriminator: this.discriminator, entity: this.getEntity(), ids: selection.map(s => s.id)})
                        .catch(this.onQueryChanged.bind(this))
            })
            .catch(e => {
                console.log(e);
            })
    }

    onGridRowDoubleClick(row) {
        this.editEntity(row)
    }

    getTitle() {
        const grid = this.getEntityGrid(),
            title = optional(grid.title, "List");
        return title;
    }

    getSubtitle() {
        const grid = this.getEntityGrid(),
            subtitle = grid.subtitle;
        return subtitle
    }

    getActions() {
        let defaultActions = [
            {
                id: "refresh",
                type: "icon",
                icon: "zmdi zmdi-refresh-alt",
                tooltip: M("refresh"),
                permissions: [this.getEntity() + ":" + Permission.LIST],
                action: () => { loadEntities({discriminator: this.discriminator, entity: this.getEntity(), query: this.state.query}) }
            }

        ]

        if(this.canCreate()){
            defaultActions.push(
                {
                    id: "create",
                    type: "icon",
                    icon: "zmdi zmdi-plus-circle",
                    tooltip: M("create"),
                    permissions: [this.getEntity() + ":" + Permission.NEW],
                    action: () => { this.createEntity() }
                },
            )
        }

        if(this.canDelete()){
            defaultActions.push({
                id: "delete",
                type: "icon",
                icon: "zmdi zmdi-delete",
                tooltip: M("delete"),
                permissions: [this.getEntity() + ":" + Permission.DELETE],
                action: () => { this.deleteEntities() }
            })
        }

        defaultActions.push({
            id: "selectAll",
            type: "icon",
            icon: "zmdi zmdi-select-all",
            tooltip: M("selectAll"),
            action: () => { this.refs.grid.toggleSelectAll() }
        });

        let grid = this.getEntityGrid()
        let matcher = new ActionsMatcher(defaultActions)
        return matcher.match(_.isFunction(grid.getActions) ? grid.getActions()  : grid.actions)
    }

    getGrid() {
        return this.refs.grid
    }

    getDescriptor() {
        let grid = this.getEntityGrid()
        return grid.descriptor
    }

    getData() {
        return resultToGridData(this.state.result)
    }

    isQuickSearchEnabled() {
        let grid = this.getEntityGrid()
        return optional(grid.quickSearchEnabled, false)
    }

    getQuickSearchPlaceholder() {
        let grid = this.getEntityGrid()
        return optional(grid.quickSearchPlaceholder, "")
    }

    getHeaderVisibleNoResults() {
        let grid = this.getEntityGrid()
        return optional(grid.headerVisibleNoResults, false)
    }

    canEdit() {
        let grid = this.getEntityGrid()
        return optional(grid.canEdit, true)
    }

    canCreate() {
        let grid = this.getEntityGrid()
        return optional(grid.canCreate, true)
    }

    canDelete() {
        let grid = this.getEntityGrid()
        return optional(grid.canDelete, true)
    }

    hideFilters() {
        return false;
    }


    selectWithCheck() {
        return optional(this.props.selectWithCheck, false)
    }

    showSidebar() {
        return parseBoolean(this.props.params?.showSidebar ?? true)
    }

    generateHeaderBlock() {
        const title = this.getTitle(),
            subtitle = this.getSubtitle(),
            actions = this.getActions();
        return (<HeaderBlock
                title={title}
                subtitle={subtitle}
                actions={actions}
            />)
    }

    renderExtra() {
        return null
    }

    getGridProps() {
        return {}
    }

    render() {

        let descriptor = this.getDescriptor()
        let data = this.getData()
        let header = this.generateHeaderBlock()
        let showSidebar = this.showSidebar()
        let tableExtra = this.generateTableHeaderExtra();

        return (
            <Layout
                hideMenuToggle={!showSidebar}
                contentFull={!showSidebar}
            >
                {showSidebar && <SideBar/>}
                {header}
                <Grid
                    ref="grid"
                    descriptor={descriptor}
                    discriminator={this.discriminator}
                    data={data}
                    query={this.state.query}
                    hideFilters={this.hideFilters()}
                    onRowDoubleClick={this.onGridRowDoubleClick.bind(this)}
                    quickSearchEnabled={this.isQuickSearchEnabled()}
                    quickSearchPlaceholder={this.getQuickSearchPlaceholder()}
                    headerVisibleNoResults={this.getHeaderVisibleNoResults()}
                    selectWithCheck={this.selectWithCheck()}
                    gridProps={this.getGridProps()}
                    extra={tableExtra}
                />

                {this.renderExtra()}
            </Layout>
        )
    }
}

export default AbstractEntitiesGrid